import { useMediaQuery, useTheme } from "@mui/material";
import { HiOutlineViewGrid } from "react-icons/hi";
import { MdGroups, MdOutlineRocketLaunch, MdExtension } from "react-icons/md";
import { IoOptions } from "react-icons/io5";
import DiamondIcon from "@mui/icons-material/Diamond";
import { MdCardGiftcard } from "react-icons/md";
import { LuHeadphones } from "react-icons/lu";
import { useContext } from "react";
import { Context } from "../../../../Store/Store";
import { mixpanelEvent } from "../../../../Utils/mixpanelUtils";
import { LINKS } from "../../../../Utils/constants";

// This is where we can control the menu item for both
// desktop and mobile
const sideBarRenderer = (user, premiumUser) => ({
  top: [
    {
      id: 0,
      title: "Sales Insights",
      link: "/Home",
      Icon: HiOutlineViewGrid,
      isShow: premiumUser,
    },
    {
      id: 1,
      title: "Customer Feed",
      link: "/NurtureProspects",
      Icon: MdGroups,
      onClick: () => {
        mixpanelEvent("left_navigation_clicked", {
          navigation_item: "Monitor",
          navigation_position: "header",
          screen_name: "Engagment community and software",
        });
      },
      isShow: premiumUser,
    },
    {
      id: 2,
      title: "Customize AI",
      link: "/CustomizeAI",
      Icon: IoOptions,
      isShow: premiumUser,
    },
    {
      id: 6,
      title: "Integrations",
      link: "/Integrations",
      Icon: MdExtension,
      onClick: () => {
        mixpanelEvent("left_navigation_clicked", {
          navigation_item: "Integrations",
          navigation_position: "header",
          screen_name: "Engagment community and software",
        });
      },
      isShow: premiumUser,
    },
    {
      id: 7,
      title: "Refer & Earn",
      link: "/ReferAndEarn",
      Icon: MdCardGiftcard,
      onClick: () => {
        mixpanelEvent("left_navigation_clicked", {
          navigation_item: "Refer & Earn",
          navigation_position: "header",
          screen_name: "Engagment community and software",
        });
      },
      isShow: premiumUser && user?.data?.group !== "Member",
    },
    {
      id: 3,
      title: "Community",
      link: "/PodCommunity",
      Icon: MdOutlineRocketLaunch,
      onClick: () => {
        mixpanelEvent("left_navigation_clicked", {
          navigation_item: "Share",
          navigation_position: "header",
          screen_name: "Engagment community and software",
        });
      },
      isShow: user?.data?.group === "Member" || user?.data?.podAccess === true,
    },
    {
      id: 4,
      title: "Upgrade to Pro",
      link: "/Billing",
      Icon: DiamondIcon,
      onClick: () => {
        mixpanelEvent("upgrade_to_pro_clicked", {
          button_text: "Upgrade to Pro",
          page_section: "Sidebar",
          screen_name: "Engagment community and software",
        });
      },
      isShow: false,
      desktopProps: {
        sx: {
          mt: "1rem",
          backgroundColor: "#FF9D00",
          border: "1px solid #B47B1F",
          color: "#FFF",
          "&:hover": {
            borderRadius: "8px",
          },
          "& .MuiListItemIcon-root": {
            color: "white",
          },
        },
      },
      mobileProps: {
        sx: {
          background: "#FF9D00",
          border: "1px solid #B47B1F",
          color: "#FFF",
          mt: 3,
          "& .MuiListItemIcon-root": { color: "#FFF" },
        },
      },
    },
  ],
  bottom: [
    {
      id: 5,
      title: "Help Centre",
      Icon: LuHeadphones,
      onClick: () => {
        mixpanelEvent("support_link_clicked", {
          link_name: "Help & Strategy Hub",
          link_section: "sidebar",
          screen_name: "Engagment community and software",
        });
        window.open(
          LINKS.HELP_CENTER,
          "_blank",
          "noopener noreferrer"
        );
      },
      isShow: true,
      mobileProps: {
        as: "a",
        href: LINKS.HELP_CENTER,
        target: "_blank",
        referrerPolicy: "nooopener noreferrer",
        disableRipple: true,
        sx: { textDecoration: "none", color: "#839BB0" },
      },
    },
  ],
});

export const SideBarContainer = (props) => {
  const { children } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const context = useContext(Context);
  const state = context[0];
  const premiumUser =
    state.user?.data?.group === "Premium" ||
    state.user?.data?.group === "Growth Plan" ||
    state.user?.data?.group === "Member" ||
    state.user?.data?.group === "Starter" ||
    state.user?.data?.group === "Trial";
  
  const sideBarContent = sideBarRenderer(state.user, premiumUser);

  return children({ isMobile, sideBarContent });
};
